import React from 'react';
import SmartDialog from "../../../../components/SmartDialog";
import {PaginatedView} from "../../../../components/PaginatedView";
import {Button, ButtonGroup} from "reactstrap";
import TTLProxy from "../../../../common/TTLAsyncProxy";
import {MiscEndpoints} from "../../../../common/ProxyEndpoints";
import Utils from "../../../../common/Utils";
import MDProgress from 'react-md-progress-bar';
import RegisterRegionDialog from "./RegisterRegionDialog";
import HTML from '../../../../common/HtmlHelpers';

class RegionsManagementDialog extends  React.Component {

    constructor(props){
        super(props);
        this.state = RegionsManagementDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
        this.loadState = this.loadState.bind(this);
    }

    static getInitialState(){

        return {
            isBusy: false,
            regions: [],
            regionsFiltered: [],
            search: '',
        };

    }

    async loadState(){

        this.setState({ isBusy: true , error: null });

        try {

            const response = await this.proxy.processRequest(MiscEndpoints.getPricingGroups());
            const payload = response.getPayload();

            this.setState({
                regions: payload,
                regionsFiltered: this.filterRegions(payload,this.state)
            });

        }
        catch (e) {

        }
        finally {

            this.setState({
                isBusy: false
            })

        }

    }

    filterRegions(regions,{ search }){
        return regions.filter(x => Utils.containsText(x.name,search) || Utils.containsText(x.description,search));
    }

    show(){
        this.setState(RegionsManagementDialog.getInitialState(),() => {

            //   show dialog
            this._dlg.show();

            //   load state
            return this.loadState();
        });
    }

    render(){

        const { regions , isBusy , regionsFiltered , search } = this.state;

        return <SmartDialog title="Manage Price Segmentation"
                            ref={r => this._dlg = r}
                            large
                            onShow={() => this.loadState()}>

            <div className="clearfix mb-2">

                <div className="pull-left">
                    <ButtonGroup>
                        <Button onClick={() => this.loadState()}><i className="fa fa-refresh"/> Refresh</Button>
                    </ButtonGroup>
                </div>

                <div className="pull-right">

                    <ButtonGroup>
                        <Button color="green" onClick={() => this._createPricingGroupDlg.show()}>Add Price Segment <i className="fa fa-plus"/></Button>
                    </ButtonGroup>

                </div>

            </div>

            <div style={{ width: "100%" }} className="mb-3">
                <input name="search" placeholder={"Search for regions..."} style={{ minWidth: 120 }} className="form-control form-input-select" value={search} onChange={evt =>{

                    const _value = evt.target.value;

                    this.setState({
                        search: _value,
                        regionsFiltered: _value ? this.filterRegions(regions, { search: _value }) : regions
                    });

                }}/>
            </div>

            {isBusy && <MDProgress show/>}

            <hr/>

            <PaginatedView data={regionsFiltered}
                           rowHeight={120}
                           noRowsHeight={480}
                           renderItem={(item,i) => {

                               return <div key={i}>

                                   {/*<div className="ml-3 mr-3 clearfix">

                                       <div style={{display: "inline"}} className="pull-left">
                                           <i className="fa fa-globe fa-3x"/>
                                       </div>

                                       <div className="ml-5">
                                           <div style={{fontSize: "small"}} className="mb-0">{item.name}</div>
                                           <div style={{fontSize: "0.8em"}} className="mb-0">Status: <h6 style={{display: "inline"}}>{item.active ? <Badge pill color="success">Active</Badge> : <Badge pill color="danger">Disabled</Badge> }</h6></div>
                                       </div>

                                       <div className="pull-right">

                                           <ButtonGroup className="m-0">
                                               <Button color={"danger"} size={"sm"}>Disable</Button>
                                           </ButtonGroup>

                                       </div>

                                   </div>*/}

                                   <div className="clearfix ml-3 mr-3 mt-2">

                                       <div className="pull-left">
                                           <h5>{item.name}</h5>

                                           <span><b>Enabled:</b> {item.active ?<span style={{ color: "green"}}>Enabled</span> : <span style={{ color: "red"}}>Disabled</span>}</span><br/>
                                           <span><b>Description:</b> {item.description || "No description provided"}</span>


                                       </div>

                                       <div className="pull-right">
                                           {item.active && <Button size="sm" color="link" onClick={async () => {

                                               if(window.confirm('Are you sure you want to disable region')){

                                                   this.setState({ isBusy: true });

                                                   try{

                                                       const res = await this.proxy.processRequest(MiscEndpoints.updatePricingGroup(item.id,{
                                                           active: false
                                                       }));

                                                       if(res.ok){
                                                           HTML.toastSuccess('Segment disabled successfully');
                                                           return  this.loadState();
                                                       }

                                                   }
                                                   catch (e) {
                                                       HTML.toastError(Utils.getResponseError(e));
                                                   }
                                                   finally {
                                                       this.setState({ isBusy: false });
                                                   }
                                               }

                                           }}><i className="fa fa-close"/> Disable</Button>}
                                           {!item.active && <Button size="sm" color="link" onClick={async () => {

                                               if(window.confirm('Are you sure you want to disable region')){
                                                   this.setState({ isBusy: true });

                                                   try{

                                                       const res = await this.proxy.processRequest(MiscEndpoints.updatePricingGroup(item.id,{
                                                           active: true
                                                       }));

                                                       if(res.ok){
                                                           HTML.toastSuccess('Segment enabled successfully');
                                                           return  this.loadState();
                                                       }

                                                   }
                                                   catch (e) {
                                                       HTML.toastError(Utils.getResponseError(e));
                                                   }
                                                   finally {
                                                       this.setState({ isBusy: false });
                                                   }

                                               }

                                           }}><i className="fa fa-check"/> Enable</Button>}
                                       </div>

                                   </div>

                               </div>
                           }}
                           emptyMessage={<div className="text-center p-5">There are no segments defined yet</div>}
                           height={480} />


                           <RegisterRegionDialog ref={r => this._createPricingGroupDlg = r}
                                                 onRegistered={() => this.loadState()}/>

        </SmartDialog>;

    }

}

export default RegionsManagementDialog;


// WEBPACK FOOTER //
// ./src/views/Extras/Services/USSDServices/RegionsManagementDialog.js